interface Provider {
  id: string
  first_name: string
  last_name_initial: string
  clinical_role: string
  title: string
}

interface Props {
  providers: Provider[]
  facets: Record<string, any>
  filters: Record<string, string>
  pagination: { current_page: number; total_pages: number; total_entries: number }
}

export default function SearchIndex({ providers, facets, filters, pagination }: Props) {
  return (
    <div>
      <h1 className="text-2xl font-semibold mb-4">Search Providers</h1>
      {/* TODO: search form, results list, facet sidebar, pagination */}
      <pre className="text-xs bg-muted p-4 rounded-md overflow-auto">
        {JSON.stringify({ providers, facets, filters, pagination }, null, 2)}
      </pre>
    </div>
  )
}
